<template>
    <div>
        <div class="ds-employee-form-data-label ds-employee-form-data-label-spacing">{{ label }}</div>
        <div class="ds-employee-form-data-value">{{ value }}</div>
    </div>
</template>

<script setup lang="ts">

interface Props {
    label: string,
    value: string | null
}

const { label, value } = defineProps<Props>()

</script>
